import { __extends } from "tslib";
import { NodeBase } from "@awayjs/view";
/**
 * Maintains scenegraph heirarchy when collecting nodes
 */
var SceneGraphNode = /** @class */ (function (_super) {
    __extends(SceneGraphNode, _super);
    function SceneGraphNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numNodes = 0;
        _this._pChildNodes = new Array();
        _this._childDepths = new Array();
        return _this;
    }
    /**
     *
     * @param traverser
     */
    SceneGraphNode.prototype.acceptTraverser = function (traverser) {
        if (this._partition.root == this._entity)
            this._partition.updateEntities();
        //get the sub-traverser for the partition, if different, terminate this traversal
        if (traverser.partition != this._partition && traverser != traverser.getTraverser(this._partition))
            return;
        if (!traverser.enterNode(this))
            return;
        var i;
        for (i = this._numNodes - 1; i >= 0; i--)
            this._pChildNodes[i].acceptTraverser(traverser);
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iAddNode = function (node) {
        node.parent = this;
        var depth = (this._entity != node.entity) ? node.entity._depthID : -16384;
        var len = this._childDepths.length;
        var index = len;
        while (index--)
            if (this._childDepths[index] < depth)
                break;
        index++;
        if (index < len) {
            this._pChildNodes.splice(index, 0, node);
            this._childDepths.splice(index, 0, depth);
        }
        else {
            this._pChildNodes.push(node);
            this._childDepths.push(depth);
        }
        this._numNodes++;
    };
    SceneGraphNode.prototype.isVisible = function () {
        return this._entity._iIsVisible();
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iRemoveNode = function (node) {
        var index = this._pChildNodes.indexOf(node);
        this._pChildNodes.splice(index, 1);
        this._childDepths.splice(index, 1);
        this._numNodes--;
    };
    return SceneGraphNode;
}(NodeBase));
export { SceneGraphNode };
